import { SonarObjectsSearchItem } from '@types';
import { SonarObjectTypeId } from '@sonar-software/sonar-ts-types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetSonarObjectsSearchRequest = {
	maxResultsPerType?: number;
	namescope?: number;
	queryString: string;
	objectTypeFilters?: Array<SonarObjectTypeId>;
};

export type GetSonarObjectsSearchResponse = Record<string, Array<SonarObjectsSearchItem>>;

export const getSonarObjectsSearch = createGetEndpoint<GetSonarObjectsSearchRequest, GetSonarObjectsSearchResponse>(
	(request) => `/api/v3/core/sonar-objects/search?${getQueryString(request)}`
);
